module.exports = __webpack_public_path__ + "components/country-flag/static/py-c1f549c6de05299c9d7a0462325202a0.svg";